import { gql } from 'apollo-boost';

export default gql`
  {
    getPluTodoItems {
      keyIndex
      shortDescription
      longDescription
      allDescriptions
      productGroupCode
      nacsCode
      nacsCodeNote
      createdDate
      modifiedDate
    }
  }
`;
